import { Sidebar } from './components/Sidebar';
import { ChatArea } from './components/ChatArea';

export default function App() {
  return (
    <div className="flex h-screen bg-neutral-950 text-white">
      <Sidebar />
      <ChatArea />
    </div>
  );
}
